import { z } from 'zod';

/**
 * The settings table stores arbitrary JSON values (string/number/boolean/
 * array/object). We accept any JSON shape on update and validate at the
 * per-setting business-rule level (if needed) in the route.
 */
export const updateSettingSchema = z.object({
  value: z.unknown(),
});

export type UpdateSettingInput = z.infer<typeof updateSettingSchema>;
